/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookBaseDto from './BookBaseDto';

/**
 * The BookListDto model module.
 * @module model/BookListDto
 * @version v1.0.0
 */
class BookListDto {
    /**
     * Constructs a new <code>BookListDto</code>.
     * @alias module:model/BookListDto
     */
    constructor() { 
        
        BookListDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookListDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookListDto} obj Optional instance to populate.
     * @return {module:model/BookListDto} The populated <code>BookListDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookListDto();

            if (data.hasOwnProperty('book')) {
                obj['book'] = ApiClient.convertToType(data['book'], [BookBaseDto]);
            }
            if (data.hasOwnProperty('bookCount')) {
                obj['bookCount'] = ApiClient.convertToType(data['bookCount'], 'Number');
            }
            if (data.hasOwnProperty('bookInventoryTotal')) {
                obj['bookInventoryTotal'] = ApiClient.convertToType(data['bookInventoryTotal'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/BookBaseDto>} book
 */
BookListDto.prototype['book'] = undefined;

/**
 * @member {Number} bookCount
 */
BookListDto.prototype['bookCount'] = undefined;

/**
 * @member {Number} bookInventoryTotal
 */
BookListDto.prototype['bookInventoryTotal'] = undefined;

/**
 * @member {String} description
 */
BookListDto.prototype['description'] = undefined;

/**
 * @member {Number} id
 */
BookListDto.prototype['id'] = undefined;

/**
 * @member {module:model/BookListDto.StatusEnum} status
 */
BookListDto.prototype['status'] = undefined;

/**
 * @member {String} title
 */
BookListDto.prototype['title'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
BookListDto['StatusEnum'] = {

    /**
     * value: "Draft"
     * @const
     */
    "Draft": "Draft",

    /**
     * value: "Publish"
     * @const
     */
    "Publish": "Publish"
};



export default BookListDto;

